$(document).ready(function () {
    $('.accordion-toggle').click(function () {
        var content = $(this).next('.accordion-body');
        var isOpen = $(this).attr('aria-expanded') === 'true';

        // Close all sections
        $('.accordion-body').slideUp(300, function () {
            $(this).removeClass('show');
        });
        $('.accordion-toggle').removeClass("show").attr('aria-expanded', 'false');

        // Toggle the clicked section
        if (!isOpen) {
            $(this).addClass("show").attr('aria-expanded', 'true');
            content.slideDown(300, function () {
                $(this).addClass('show');
            });
        }
    });
});
